<template>

<section>
  <div v-if="folders.length>0" >
    <p class="better-menu-label d-flex align-items-center">
     <FolderIcon class="mr-1"/>
     <span class="fs-4 fw-800"> Folders </span>
     <span class="my-tag">{{ folders.length }}</span>
      <button
        @click="showAddFolderModal = true"
        type='button'
        class='button is-small is-primary is-outlined mb-4-if-mobile'
        id="add-folder"
        name='add folder'>
        + Add Folder
      </button>
    </p>
    <input type="text" class="input mt-1" v-if="folders.length > 5" v-model="folderQuery" placeholder="Filter folders">

    <Loader v-if="loading"/>
    <p v-else-if="error" class="text-center pt-2 pb-2 text-muted">
      Error fetching folders
    </p>
    <ul v-else class="menu-list scroll-container mt-2 mb-2">
      <li v-for="f in filteredFolders">
        <router-link class="is-primary d-flex align-items-center flex-wrap break-word" :to="'/folders/' + f.id">
          <span class="mr-2">{{ f.title }}</span>
          <SharedWithUsersIcon
            v-if="f.shared"
            width="1rem"
            height="1rem"
          />
        </router-link>
      </li>
      <p class="text-muted italic p-2" v-if="folders && folders.length === 0" >No folders</p>
    </ul>
  </div>

  <AddFolderModal
    v-if=this.showAddFolderModal
    @close="showAddFolderModal = false"
    />

</section>
</template>

<script>
import store from '../store'
import FolderIcon from './FolderIcon'
import Loader from './Loader'
import SharedWithUsersIcon from './SharedWithUsersIcon.vue'
import AddFolderModal from './AddFolderModal.vue'

const matchQuery = ({ title, description, owner_name: ownerName }, query) => {
  if (title == null) {
    title = ''
  }
  if (description == null) {
    description = ''
  }
  if (ownerName == null) {
    ownerName = ''
  }
  const removeAccents = x => x.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  const normalize = (x = '') => removeAccents(x).replace(/(\W|_)/g, '').toLowerCase()

  title = normalize(title)
  description = normalize(description)
  ownerName = normalize(ownerName)
  query = normalize(query)

  return title.includes(query) || description.includes(query) || ownerName.includes(query)
}

export default {
  name: 'FolderSection',
  components: {
    FolderIcon,
    Loader,
    SharedWithUsersIcon,
    AddFolderModal,
  },
  data () {
    return {
      loading: true,
      error: false,
      folderQuery: '',
      sharedFolderQuery: '',
      showAddFolderModal: false,
    }
  },
  async mounted () {
    try {
      await store.dispatch('fetchFolders')
    } catch (err) {
      this.error = true
    }
    this.loading = false
  },
  computed: {
    userID () {
      return store.state.user.id
    },
    filteredFolders () {
      return this.folders.filter(x => matchQuery(x, this.folderQuery))
    },
    folders () {
      return store.state.folders.concat(store.state.sharedFolders)
    }
  },
}
</script>



// WEBPACK FOOTER //
// FolderSection.vue?0f8c2bfc